import RightArrowIcon from "../../assets/svgs/right-arrow.svg";
import ThunderSvgIcon from "../../assets/svgs/thunder.svg";
import { Badge } from "../../components/core/badge.core";
import Button from "../../components/core/button.core";
import { useGetWorkspaceHttp } from "../../hooks/http/colab/workspace/get-workspace.hook";
import useWorkspaceStore from "../../store/workspace.store";
import { useUserStore } from "../../../store/user.store";
import { useEffect } from "react";
import Spinner from "../../../components/spinner.components";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useJoinWorkspaceHttp } from "../../hooks/http/colab/workspace/join-workspace.hook";
import { useDashboardConfigCommonHttp } from "../../../hooks/http/common/users/dashboard-config.common.http";
import { handleHttpError } from "../../../utils/utils";
import { useToast } from "../../../hooks/use-toast";

export default function WorkspacePartial() {
  const { brands, setBrands } = useUserStore();

  const { execute: fetchConfig, fetching: fetchingConfig } =
    useDashboardConfigCommonHttp();

  const { toast } = useToast();

  const { execute: fetchWorkspaceHttp, fetching: fetchingWorkspace } =
    useGetWorkspaceHttp();
  const { data: workspaceData, setData: setWorkspaceData } =
    useWorkspaceStore();

  const { execute: joinWorkspaceHttp, fetching: fetchingJoinWorkspace } =
    useJoinWorkspaceHttp();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const proposalId = searchParams.get("proposalId");

  async function getConfig() {
    const response = await fetchConfig({ body: null });
    if (!response.success) {
      handleHttpError(response, toast);
      return;
    }
    setBrands(response.data.brands);
  }

  async function joinWorkspace(brandId: string) {
    const response = await joinWorkspaceHttp({
      pathParams: { id: brandId },
      body: null,
    });
    if (!response.success) {
      return;
    }

    await getConfig();
    navigate(proposalId ? `/brands/proposal/${proposalId}` : "/brands");
  }

  async function fetchWorkspace() {
    const response = await fetchWorkspaceHttp({
      body: null,
    });
    if (!response.success) {
      navigate("/brands/workspace/create");
      return;
    }
    setWorkspaceData(response.data.brands[0]);
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (brands?.length) {
      return navigate("/brands");
    }

    fetchWorkspace();

    if (!workspaceData && !brands?.length) {
      return navigate("/brands/workspace/create");
    }
  }, [brands?.length]);
  if (fetchingWorkspace) {
    return (
      <div className="flex justify-center items-center w-full h-screen">
        <Spinner className="text-black" />
      </div>
    );
  }

  if (!workspaceData) return <Navigate to="/brands/workspace/create" />;

  return (
    <div className="flex flex-col justify-center items-center p-5 w-full h-screen text-soloprimary">
      <div className="flex flex-col justify-center items-center w-full max-w-lg h-full">
        <div className="flex flex-col items-center bg-soloCardBg px-10 md:px-0 pt-10 md:pt-32 border border-b-0 border-black rounded-b-none rounded-xl w-full md:h-[90vh]">
          <div className="flex flex-col items-center gap-3 w-full">
            <Badge
              className="flex items-center gap-1 md:gap-2 px-4 md:px-6 md:py-2 font-figtree text-[10px] md:text-sm tracking-tight"
              variant="3d"
            >
              <ThunderSvgIcon />
              your company already has a solo account!
              <ThunderSvgIcon />
            </Badge>
            <p className="font-cabinetgrotesk font-normal text-2xl md:text-[40px] tracking-tight">
              Join your brand workspace
            </p>
          </div>
          <div className="flex flex-col items-center pt-14 md:pt-16 pb-24">
            <Button className="p-0" variant="solid">
              <img
                src={workspaceData.logo?.url}
                alt=""
                className="rounded-xl w-28 h-28"
              />
            </Button>
            <p className="pt-6 pb-2.5 font-cabinetgrotesk font-normal text-xl md:text-[32px] tracking-tight">
              {workspaceData.name} on solo
            </p>
          </div>
        </div>
        <div className="relative bg-gray-700 pb-1 border border-black rounded-b-2xl w-full overflow-hidden">
          <Button
            onClick={() => joinWorkspace(workspaceData.id)}
            isLoading={fetchingJoinWorkspace || fetchingConfig}
            className="border-0 rounded-t-none w-full md:text-lg"
          >
            <p className="pr-3 font-medium">Join brand workspace</p>{" "}
            <RightArrowIcon />
          </Button>
        </div>
      </div>
    </div>
  );
}
